import {
  PhoneArrowDownLeftIcon,
  PhoneArrowUpRightIcon,
} from "@heroicons/react/24/solid";
import StatCard from "./Components/StatCard";

export default function ConversationBySource(props) {
  const { conversationCountBySource, isLoading } = props;

  return (
    <>
      <StatCard
        label="Total Inbound Calls"
        value={conversationCountBySource?.INBOUNDVOICE?.toLocaleString() ?? 0}
        icon={<PhoneArrowDownLeftIcon className="size-6 text-gray-500" />}
        isLoading={isLoading}
      />
      <StatCard
        label="Total Outbound Calls"
        value={conversationCountBySource?.OUTBOUNDVOICE?.toLocaleString() ?? 0}
        icon={<PhoneArrowUpRightIcon className="size-6 text-gray-500" />}
        isLoading={isLoading}
      />
    </>
  );
}
